module.exports = __webpack_public_path__ + "media/images/cart-cc826e16d43d57f25c05a3f54f0824bf.png";